import MenuContentComponent from '../components/Menu/MenuContent/viewer/MenuContent';


const MenuContent = {
  component: MenuContentComponent
};


export const components = {
  ['MenuContent']: MenuContent
};

